import { NUM_CORE_WEEKLY_CLASSES_TO_MONTHLY_CORE_SUB_PRICE } from 'constants/signup_sessions';
import { BundleData } from '../types';
import sumWeeklyClasses from './sumWeeklyClasses';

const makePriceBeforeCoupon = (bundle: BundleData['selections']): number =>
  NUM_CORE_WEEKLY_CLASSES_TO_MONTHLY_CORE_SUB_PRICE[sumWeeklyClasses(bundle)];

export default makePriceBeforeCoupon;
